import React, { useEffect, useState } from 'react';
import { fetchSymbolUrl } from '../utils/backendServices';

interface SymbolImageProps {
    symbolId: string;
}

const SymbolImage: React.FC<SymbolImageProps> = ({ symbolId }) => {
    const [symbolUrl, setSymbolUrl] = useState<string | null>(null);
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        const loadSymbolUrl = async () => {
            setError(false);

            try {
                const newSymbolUrl = await fetchSymbolUrl(symbolId);
                setSymbolUrl(newSymbolUrl);
            } catch (err) {
                console.error(`Error fetching symbol ${symbolId}:`, err);
                setError(true);
            }
        };

        loadSymbolUrl();
    }, [symbolId]);

    if (error) {
        return <img alt={`Failed to load symbol ${symbolId}`} />;
    }

    if (symbolUrl) {
        return <img src={symbolUrl} alt={`Symbol ${symbolId}`} />;
    }

    return null;
};

export default SymbolImage;
